import { createElementVNode as _createElementVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74eddc97"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sm:hidden flex justify-content-center" }
const _hoisted_2 = { class: "w-full flex align-items-start sm:align-items-center justify-content-between gap-2 mt-4" }
const _hoisted_3 = { class: "flex gap-4 align-items-center" }
const _hoisted_4 = { class: "flex flex-column gap-4" }
const _hoisted_5 = { class: "text-xl font-bold sm:text-primary" }
const _hoisted_6 = {
  key: 0,
  class: "block text-lg text-gray-500 mt-2"
}
const _hoisted_7 = { class: "wp1200 pb-2 px-2 sm:py-0 text-900" }
const _hoisted_8 = { class: "mt-4" }
const _hoisted_9 = { class: "flex flex-col sm:align-items-center sm:justify-content-start gap-2 sm:gap-5 flex-wrap" }
const _hoisted_10 = { class: "mt-1 sm:mb-0 mb-3" }
const _hoisted_11 = { class: "flex gap-3" }
const _hoisted_12 = { class: "flex align-items-center gap-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_car text-2xl" }, null, -1))
const _hoisted_14 = { class: "sm:text-2xl font-semibold" }
const _hoisted_15 = { class: "flex align-items-center gap-2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_electricity_1 text-2xl" }, null, -1))
const _hoisted_17 = { class: "sm:text-2xl font-semibold" }
const _hoisted_18 = { class: "flex align-items-center gap-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_parking text-2xl" }, null, -1))
const _hoisted_20 = { class: "sm:text-2xl font-semibold" }
const _hoisted_21 = { class: "table gap-2 mt-1 sm:w-4 w-full" }
const _hoisted_22 = { class: "font-normal" }
const _hoisted_23 = { class: "text-center" }
const _hoisted_24 = { class: "font-normal" }
const _hoisted_25 = { class: "text-center" }
const _hoisted_26 = { class: "font-normal" }
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = { class: "font-normal" }
const _hoisted_29 = { class: "text-center" }
const _hoisted_30 = { class: "font-normal" }
const _hoisted_31 = { class: "text-center" }
const _hoisted_32 = { class: "font-normal" }
const _hoisted_33 = { class: "text-center" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_arrow-R" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Sidebar = _resolveComponent("Sidebar")!

  return (_openBlock(), _createBlock(_component_Sidebar, {
    visible: true,
    dismissable: false,
    position: "bottom",
    modal: false,
    "show-close-icon": false,
    class: "bottomSheet"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "handle",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'SharedMobilityMap' })))
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("i", {
            tabindex: "0",
            class: "hidden sm:block icon-warpit_icon_arrow-L font-bold text-xl text-gray-500 cursor-pointer",
            onClick: _cache[1] || (_cache[1] = () => _ctx.goBack()),
            onKeyup: _cache[2] || (_cache[2] = _withKeys(() => _ctx.goBack(), ["enter"]))
          }, null, 32),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.station.name), 1),
              (_ctx.station.address)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.station.address), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Divider, { class: "mb-4" }),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.station.all_cars), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.station.chargers), 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.station.free_parking_places), 1)
                ])
              ])
            ]),
            _createVNode(_component_Divider, { class: "block mt-0 mb-0" }),
            _createElementVNode("table", _hoisted_21, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.$t("shared_mobility.all_cars")), 1),
                  _createElementVNode("td", _hoisted_23, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.station.all_cars), 1)
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.$t("shared_mobility.reservable_cars")), 1),
                  _createElementVNode("td", _hoisted_25, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.station.reservable_cars), 1)
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.$t("shared_mobility.reserved_cars")), 1),
                  _createElementVNode("td", _hoisted_27, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.station.reserved_cars), 1)
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.$t("shared_mobility.chargers")), 1),
                  _createElementVNode("td", _hoisted_29, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.station.chargers), 1)
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.$t("shared_mobility.charger_points")), 1),
                  _createElementVNode("td", _hoisted_31, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.station.charger_points), 1)
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.$t("shared_mobility.free_parking_places")), 1),
                  _createElementVNode("td", _hoisted_33, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.station.free_parking_places), 1)
                  ])
                ])
              ])
            ])
          ]),
          _createVNode(_component_Divider, { class: "sm:hidden mb-4" }),
          _createVNode(_component_Button, {
            class: "defaultButton flex align-items-center justify-content-between sm:w-4 px-4 mt-5 sm:mb-3 w-full",
            icon: "pi pi-arrow-right",
            iconPos: "right",
            onClick: _ctx.openGoogleMaps
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("shared_mobility.directions")) + " ", 1),
              _hoisted_34
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createElementVNode("button", {
            class: "hidden sm:block bg-transparent border-none text-black-alpha-50 text-lg underline cursor-pointer p-0",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goBack(true)))
          }, _toDisplayString(_ctx.$t("shared_mobility.info.back")), 1)
        ])
      ])
    ]),
    _: 1
  }))
}